/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable-next-line react/jsx-wrap-multilines */
/* eslint-disable-next-line react/jsx-one-expression-per-line */
/* eslint-disable-next-line react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { Chip } from '@material-ui/core';
import moment from 'moment';
import { useQuery, useMutation } from '@apollo/react-hooks';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';
import Spinner from '@salesforce/design-system-react/components/spinner';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Icon from '@salesforce/design-system-react/components/icon';
import Input from '@salesforce/design-system-react/components/input';
import { useSelector } from 'react-redux';
import ContactModal from './ContactModal';
import { getUserInfo } from '../../../../../store/ducks/userInfo';
import '../../index.scss';
import { GET_USER_CONTACTS } from '../../../../../graphql/getUserContacts';
import { ContactRole, DEFAULT_EMAIL_BODY, USAGE_TYPE } from '../../../../../util/constants';
import { composeEmailFromSpec } from './emailHelpers';
import { UserEmailConfiguration } from '../../../../NotificationCenter/NotificationEmailConfiguration';
import { GET_FAVOURITE_CONTACTS } from '../../../../../graphql/getFavouriteContacts';
import CREATE_UPDATE_FAVOURITE_CONTACT from '../../../../../graphql/mutations/createOrDeleteFavourites';
import { GET_USER_EMAIL_CONFIGURATION } from '../../../../../graphql/getUserEmailConfiguration';
import { GET_USER_INFO } from '../../../../../graphql/getUserInfoData';
import { useTerritoryTeam } from './useTerritoryTeam';
import Env from '../../../../../util/env';

interface Option {
  id: string;
  name: string;
  email: string;
  label?: string;
  isfavourite?: boolean;
  __typename: string;
  contactRole: string;
}
interface Props {
  open: boolean;
  pdfTitle: string;
  showPrice: boolean;
  sendingEmail: boolean;
  usageDetails?: any;
  adminFormConfigurationsData?: any;
  formConfigurationsData?: any;
  handleToggleModal: () => void;
  handleSendEmail: (
    emails: string[],
    body: string,
    subject: string,
    isExcelModal?: boolean
  ) => void;
  excelFileUrl?: string;
  isExcelModal?: boolean;
  isPDFModal?: boolean;
}

const EmailModal: FC<Props> = ({
  open,
  showPrice,
  pdfTitle,
  sendingEmail,
  handleToggleModal,
  handleSendEmail,
  usageDetails,
  adminFormConfigurationsData,
  formConfigurationsData,
  excelFileUrl,
  isExcelModal,
  isPDFModal,
}) => {
  const { territoryTeam } = useTerritoryTeam();
  const userInfo = useSelector(getUserInfo);
  const businessUnit = userInfo?.businessunit || 'Sports Med';
  const [inputAddress, setInputAddress] = useState('');
  const [inputSubject, setInputSubject] = useState('');
  const [emailAddresses, setEmailAddresses] = useState<any[]>([]);
  const [manuallyEnteredEmail, setManuallyEnteredEmail] = useState<any[]>([]);
  const [contactModalVisible, setContactModalVisible] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userContacts, setUserContacts] = useState<any[]>([]);
  const [removedTerritoryEmails, setRemovedTerritoryEmails] = useState<string[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [favourites, setFavourites] = useState<Option[]>([]);
  const [setFavouriteData] = useMutation(CREATE_UPDATE_FAVOURITE_CONTACT);
  const { accountNumber, accountName, eventDateTime, eventId, caseNumber, caseId } =
    usageDetails && usageDetails;
  const surgeryDate = (eventDateTime && moment.utc(eventDateTime).format('MM/DD/YYYY')) || '';

  const { data: getUserContacts } = useQuery(GET_USER_CONTACTS, {
    fetchPolicy: 'no-cache',
    variables: {
      userId: usageDetails?.salesRepId || userInfo?.id,
      accountId: usageDetails?.accountId,
    },
  });

  const { data: getFavouriteContacts } = useQuery(GET_FAVOURITE_CONTACTS, {
    fetchPolicy: 'no-cache',
    variables: {
      salesRepId: usageDetails?.salesRepId || userInfo?.id,
      accountId: usageDetails?.accountId,
    },
  });

  const address: any = {
    'Street Address 1': '',
    'Street Address 2': '',
    City: '',
    Country: '',
    State: '',
    'Zip Code': '',
  };

  let salesRepConfigEmail = '';
  const finalRules = adminFormConfigurationsData[0]?.businessRules;
  finalRules.forEach((br: any): void => {
    if (br.rules in address) {
      address[br.rules] = br.values;
    }

    if (br.rules === 'Email' && br.values && br.isRequired === true) {
      salesRepConfigEmail = br.values;
    }
  });

  const emailBodyData = usageDetails || '';
  const billOnlyConfig = formConfigurationsData.billOnly[2].fields;
  const shipAndBillConfig = formConfigurationsData.shipAndBill[2].fields;

  if (usageDetails?.diplayOrderType === USAGE_TYPE.BILL_ONLY && billOnlyConfig) {
    billOnlyConfig.forEach((billOnlyData: any) => {
      if (billOnlyData.isShow === false) {
        if (billOnlyData.name === 'procedure') {
          emailBodyData.procedureName = null;
        } else if (billOnlyData.name === 'surgeon') {
          emailBodyData.surgeonFirstName = null;
          emailBodyData.surgeonLastName = null;
        } else if (billOnlyData.name === 'po') {
          emailBodyData.poNumber = null;
        } else if (billOnlyData.name === 'surgeryDate') {
          emailBodyData.eventDateTime = null;
        } else if (billOnlyData.name === 'patientID') {
          emailBodyData.patientId = null;
        } else {
          emailBodyData[billOnlyData.name] = null;
        }
      }
    });
  }

  if (usageDetails?.diplayOrderType === USAGE_TYPE.SHIP_AND_BILL && shipAndBillConfig) {
    shipAndBillConfig.forEach((SnBData: any) => {
      if (SnBData.isShow === false) {
        if (SnBData.name === 'procedure') {
          emailBodyData.procedureName = null;
        } else if (SnBData.name === 'surgeon') {
          emailBodyData.surgeonFirstName = null;
          emailBodyData.surgeonLastName = null;
        } else if (SnBData.name === 'po') {
          emailBodyData.poNumber = null;
        } else if (SnBData.name === 'surgeryDate') {
          emailBodyData.eventDateTime = null;
        } else if (SnBData.name === 'patientID') {
          emailBodyData.patientId = null;
        } else {
          emailBodyData[SnBData.name] = null;
        }
      }
    });
  }

  const {
    data: cfgData,
    loading: cfgLoading,
    error: cfgError,
    refetch: refetchEmailConfig,
  } = useQuery(GET_USER_EMAIL_CONFIGURATION, { fetchPolicy: 'cache-and-network' });
  const userCfg = cfgData?.getUserEmailConfiguration as UserEmailConfiguration | undefined;

  // Query sales rep info if salesRepId is available
  const { data: salesRepData, loading: salesRepLoading, error: salesRepError } = useQuery(
    GET_USER_INFO,
    {
      variables: { id: usageDetails?.salesRepId },
      skip: !usageDetails?.salesRepId,
      fetchPolicy: 'cache-first',
    }
  );
  const salesRepInfo = salesRepData?.getUserInfo?.[0];

  const baseBody = DEFAULT_EMAIL_BODY(usageDetails, businessUnit, address, salesRepConfigEmail);
  const [emailBody, setEmailBody] = useState<string>(baseBody);

  // Refetch email configuration when modal opens
  useEffect(() => {
    if (open && refetchEmailConfig) {
      refetchEmailConfig();
    }
  }, [open, refetchEmailConfig]);

  useEffect(() => {
    if (cfgLoading || cfgError || salesRepLoading || salesRepError) return;
    const finalBody = composeEmailFromSpec(baseBody, userCfg, usageDetails, salesRepInfo);
    setEmailBody(finalBody);
  }, [
    cfgLoading,
    cfgError,
    salesRepLoading,
    salesRepError,
    baseBody,
    userCfg,
    salesRepInfo,
    usageDetails,
  ]);

  const getEmailsFromInput = (inputString: string): string[] => {
    const emailArray = inputString.split(/[\s, ;]+/);
    const emails = [...emailArray];
    if (emailArray.pop() === '') {
      return emailArray;
    }
    return emails;
  };

  const addEmailAddress = useCallback(
    (e: any): void => {
      if (
        e.target.name === 'ss_email' &&
        e.target.value &&
        (e.key === 'Enter' || e.keyCode === 13)
      ) {
        const tempManuallyEnteredEmail = getEmailsFromInput(e.target.value);
        const tempEmails = [...emailAddresses, ...tempManuallyEnteredEmail];
        setEmailAddresses(tempEmails);
        const tempManualEmail = [...manuallyEnteredEmail, ...tempManuallyEnteredEmail];
        setManuallyEnteredEmail(tempManualEmail);
        setInputAddress('');
      }
    },
    [emailAddresses, manuallyEnteredEmail]
  );

  const sendEmail = (): void => {
    let emailIds = [];
    emailIds = [...emailAddresses];
    if (inputAddress) {
      const values = getEmailsFromInput(inputAddress);
      emailIds = [...emailAddresses, ...values];
    }
    if (territoryTeam && Array.isArray(territoryTeam.members)) {
      // Create copy of members array
      const membersForEmail = [...territoryTeam.members];

      // Check if salesRepEmail exists in territoryTeam
      const salesRepEmail = userInfo?.salesRepEmail;
      const salesRepExists = territoryTeam.members.some(
        (member: any) => member.email === salesRepEmail
      );

      // If not present, add it temporarily for sending
      if (!salesRepExists && salesRepEmail) {
        membersForEmail.push({
          email: salesRepEmail,
          name:
            userInfo?.firstName && userInfo?.lastName
              ? `${userInfo.firstName} ${userInfo.lastName}`
              : salesRepEmail,
          __typename: ContactRole.TERRITORY_TEAM,
        });
      }

      const memberEmails = membersForEmail
        .filter((member: any) => !removedTerritoryEmails.includes(member.email))
        .map((member: any) => member.email);
      emailIds = [...emailIds, ...memberEmails];
    }
    emailIds = emailIds.filter((email, idx, arr) => arr.indexOf(email) === idx);
    handleSendEmail(emailIds, emailBody, inputSubject, isExcelModal);
  };
  useEffect(() => {
    window.addEventListener('keyup', addEmailAddress);
    return (): void => {
      window.removeEventListener('keyup', addEmailAddress);
    };
  }, [addEmailAddress]);

  const handleEmailAddress = (event: any): void => {
    setInputAddress(event.target.value);
  };

  const handleSubject = (event: any): void => {
    setInputSubject(event.target.value);
  };

  const handleContactModalVisible = (): void => {
    setUserContacts(getUserContacts?.getUserContacts);
    setContactModalVisible(!contactModalVisible);
  };

  const handleAdd = (contacts: Option[]): void => {
    if (contacts && contacts?.length > 0) {
      const filteredEmails = contacts.map((item: Option) => item?.email);
      const arr = [...manuallyEnteredEmail, ...filteredEmails];
      setEmailAddresses(arr.filter((item, index) => arr.indexOf(item) === index));
    }
    setLoading(false);
    setContactModalVisible(!contactModalVisible);
  };

  const handleAddPress = (): void => {
    setContactModalVisible(!contactModalVisible);
  };

  const findData = (options: Option[], data: Option): Option[] => {
    return options.filter(
      (element: Option) => element.name === data.name && element.email === data.email
    );
  };

  const handleDelete = (email: string, index: number): void => {
    const tempAddress = [...emailAddresses];
    tempAddress.splice(index, 1);
    setEmailAddresses(tempAddress);
    setManuallyEnteredEmail(manuallyEnteredEmail.filter(element => element !== email));
    setSelectedOptions(options =>
      options.filter(item => item?.email.toLowerCase() !== email.toLowerCase())
    );
  };

  const toggleOption = (option: Option): void => {
    if (findData(selectedOptions, option).length) {
      setSelectedOptions(
        selectedOptions.filter(
          element => element.name !== findData(selectedOptions, option)[0].name
        )
      );
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const toggleFavorite = (option: Option): void => {
    if (findData(favourites, option).length) {
      setFavourites(
        favourites.filter(element => element.name !== findData(favourites, option)[0]?.name)
      );
    } else {
      setFavourites([...favourites, option]);
      if (!findData(selectedOptions, option).length) {
        setSelectedOptions([...selectedOptions, option]);
      }
    }
  };

  const removeSelectedOption = (option: Option): void => {
    setSelectedOptions(
      selectedOptions.filter(
        element => element.email !== findData(selectedOptions, option)[0]?.email
      )
    );
  };

  const handleAddContacts = (contacts: Option[]): void => {
    setLoading(true);
    const favouritesForPayload: any[] = [];
    favourites.forEach(data => {
      favouritesForPayload.push({
        email: data.email,
        name: data.name,
      });
    });
    const mutation = {
      salesRepId: usageDetails?.salesRepId || userInfo?.id,
      favourites: favouritesForPayload,
      accountId: usageDetails?.accountId,
    };
    setFavouriteData({
      variables: mutation,
    })
      .then(() => {
        setFavourites(favourites);
        handleAdd(contacts);
      })
      .catch();
  };

  const handleSearch = (event: ChangeEvent<HTMLInputElement>): void => {
    const searchTerm = event.target.value;
    const results = getUserContacts?.getUserContacts.filter(
      (item: Option) =>
        item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.email?.includes(searchTerm)
    );
    setUserContacts(results);
  };

  useEffect(() => {
    const favouriteEmails = (getFavouriteContacts?.getFavourites ?? []).map(
      (data: Option) => data.email
    );

    setEmailAddresses(favouriteEmails);

    setFavourites(
      (getUserContacts?.getUserContacts ?? []).filter((data: Option) => data.isfavourite === true)
    );
    setSelectedOptions(getFavouriteContacts?.getFavourites ?? []);
    setUserContacts(getUserContacts?.getUserContacts ?? []);
  }, [getFavouriteContacts, getUserContacts]);

  return (
    <IconSettings iconPath="/icons">
      <Modal
        className="filter-modal surgery-sheet-email-modal default-modal_header default-modal_footer"
        ariaHideApp={false}
        isOpen={open}
        onRequestClose={handleToggleModal}
        footer={[
          <div className="usage-modal-footer">
            {sendingEmail && <Spinner size="small" />}
            <Button label="Close" key="Close" onClick={handleToggleModal} />
            <Button
              className="yellow-btn"
              label="Send"
              disabled={!inputAddress && emailAddresses?.length === 0}
              onClick={sendEmail}
              variant="brand"
              key="save"
            />
          </div>,
        ]}
        heading={[<div style={{ textAlign: 'start' }}>Email</div>]}
      >
        <section className="slds-p-around_medium slds-theme_shade">
          <section style={{ background: 'white' }}>
            {((emailAddresses && emailAddresses.length > 0) ||
              (territoryTeam &&
                Array.isArray(territoryTeam.members) &&
                territoryTeam.members.length > 0)) && (
              <>
                <div
                  className="slds-p-around_large-1"
                  style={{ display: 'flex', flexWrap: 'wrap' }}
                >
                  {(emailAddresses ?? []).map((val: any, index: number): any => (
                    <div key={`email-${val}-${index}`} style={{ padding: '5px' }}>
                      <Chip
                        label={val}
                        size="medium"
                        onDelete={(): void => handleDelete(val, index)}
                      />
                    </div>
                  ))}
                  {territoryTeam &&
                    Array.isArray(territoryTeam.members) &&
                    (() => {
                      // Check if salesRepEmail exists in territoryTeam
                      const salesRepEmail = userInfo?.salesRepEmail;
                      const salesRepExists = territoryTeam.members.some(
                        (member: any) => member.email === salesRepEmail
                      );

                      // If not present, add it temporarily for display
                      const membersToShow = [...territoryTeam.members];
                      if (!salesRepExists && salesRepEmail) {
                        membersToShow.push({
                          email: salesRepEmail,
                          name:
                            userInfo?.firstName && userInfo?.lastName
                              ? `${userInfo.firstName} ${userInfo.lastName}`
                              : salesRepEmail,
                          __typename: ContactRole.TERRITORY_TEAM,
                        });
                      }

                      return membersToShow
                        .filter((member: any) => !removedTerritoryEmails.includes(member.email))
                        .map((member: any, idx: number) => (
                          <div
                            key={`territory-${territoryTeam.territoryName}-${member.email}-${idx}`}
                            style={{ padding: '5px' }}
                          >
                            <Chip
                              label={member.email}
                              size="medium"
                              onDelete={() =>
                                setRemovedTerritoryEmails(prev => [...prev, member.email])
                              }
                              style={{ background: '#e0e0e0' }}
                            />
                          </div>
                        ));
                    })()}
                </div>
              </>
            )}
            <div className="slds-p-around_large-1">
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '24fr 1fr ',
                }}
              >
                <Input
                  name="ss_email"
                  label="Add Recipients:"
                  id="ss_email"
                  onChange={handleEmailAddress}
                  value={inputAddress}
                  onPressEnter
                />
                <div
                  style={{
                    display: 'flex',
                    marginTop: '25px',
                    marginLeft: '10px',
                    alignItems: 'center',
                  }}
                  onClick={handleAddPress}
                >
                  <Icon category="utility" name="new" size="small" />
                </div>
              </div>
              <span>Note: Paste comma/semicolon separated email addresses and press Enter</span>
            </div>
            <div
              style={{ display: 'grid', gridTemplateColumns: '2fr 27fr ' }}
              className="slds-p-around_large-1 "
            >
              <p style={{ fontWeight: 'bold', padding: '2px' }}>Subject:</p>
              <div style={{ marginTop: '-11px' }}>
                <Input
                  name="ss_subject"
                  label=""
                  id="ss_subject"
                  onChange={handleSubject}
                  value={
                    inputSubject ||
                    `Stryker Order Request for ${accountNumber}-${accountName}/${eventId ||
                      caseNumber ||
                      ''}/${surgeryDate.replace(/\//g, '-')}`
                  }
                  onPressEnter
                />
              </div>
            </div>
            <div className="slds-p-around_large-1">
              <p style={{ fontSize: '15px', padding: '0px 5px' }}>Message:</p>
              <textarea
                id="unique-id-1"
                rows={8}
                className="slds-textarea"
                value={emailBody || ''}
                onChange={(event: any): void => setEmailBody(event.target.value)}
              />
            </div>
            <div>
              <div className="slds-p-around_large-1 ">
                <p style={{ fontWeight: 'bold' }}>Attachment</p>
                {isExcelModal && excelFileUrl && (
                  <>
                    <Icon category="utility" name="attach" size="small" />
                    <a
                      href={excelFileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ padding: '0px 5px' }}
                      download={`${pdfTitle}.xlsx`}
                    >
                      {`${pdfTitle}.xlsx`}
                    </a>
                  </>
                )}
                {isPDFModal && (!isExcelModal || !excelFileUrl) && (
                  <>
                    <Icon category="utility" name="attach" size="small" />
                    <a
                      href={`${Env.REACT_APP_GRAPHQL_URL.replace('graphql', '')}services/${
                        showPrice ? 'getInvoiceWithPrice' : 'getInvoiceWithoutPrice'
                      }?case_id=${caseId}&toggle_price_flag=${showPrice}&surgery_date=${surgeryDate}`}
                      target="blank"
                      style={{ padding: '0px 5px' }}
                    >
                      {`${pdfTitle}.pdf`}
                    </a>
                  </>
                )}
              </div>
            </div>
          </section>
        </section>
        {contactModalVisible && (
          <ContactModal
            loading={loading}
            allContacts={getUserContacts?.getUserContacts}
            handleContactModalVisible={handleContactModalVisible}
            contactModalVisible={contactModalVisible}
            handleAddContacts={(result: Option[]): void => {
              handleAddContacts(result);
            }}
            selectedContact={emailAddresses}
            contactsDataOption={userContacts}
            favourites={favourites}
            toggleFavorite={(result: Option): void => {
              toggleFavorite(result);
            }}
            selectedOptions={selectedOptions}
            toggleOption={(result: Option): void => {
              toggleOption(result);
            }}
            removeSelectedOption={(result: Option): void => {
              removeSelectedOption(result);
            }}
            handleSearch={(result: ChangeEvent<HTMLInputElement>): void => {
              handleSearch(result);
            }}
          />
        )}
      </Modal>
    </IconSettings>
  );
};

export default EmailModal;
